<template>
  <b-container class="chat-box">
    <b-row>
      <b-col cols="12" lg="10" class="mx-auto">
        <!-- Interaction component first, chatbot below it. -->
        <MaterialApplicationStep
          :style="{
            '--main-color': mainColor,
            '--secondary-color': secondaryColor,
          }"
          :context="context"
          class="mb-4"
          @go-to-step="goToStep"
          @no-uses="scrollToChat"
        />
        <div
          v-for="(msg, msgidx) in messages"
          :key="msgidx"
          class="chat-record mt-2"
        >
          <ChatMessageComponent
            :style="{
              '--main-color': mainColor,
              '--secondary-color': secondaryColor,
            }"
            :initMsg="msg"
            :key="msgidx"
            :msgidx="msgidx"
            :ref="`msgRef-${msg.name}`"
            :context="context"
            @select-card="handleCardClick"
            @increase="handleIncrease"
            @decrease="handleDecrease"
            @continue="continueChat"
            @scroll-to-bottom="scrollToBottom"
            @scroll-to-msg="scrollToMsg"
            @select-checkbox="handleCheckbox"
            @set-text-input="setTextInput"
            @selector-change="handleSelectorChange"
            @go-to-step="goToStep"
          />
          <div>
            <b-row
              v-if="msg.isFinal"
              class="w-100 reset-button py-2 m-1"
              @click="resetChat"
            >
              <b-col>Reiniciar chat</b-col>
            </b-row>
          </div>
        </div>
      </b-col>
      <!-- <b-col col lg="2" class="d-none d-sm-block">
          <b-card
            bg-variant="light"
            title="Costo:"
            style="position: sticky; top: 4em"
          >
            <b-card-text>
              <b>{{ cost }}</b>
              <b-img :src="appleIcon" width="22px" class="pl-1 mb-2 mx-0" />
            </b-card-text>
          </b-card>
        </b-col> -->
    </b-row>
  </b-container>
</template>
<script>
import informationService from "@/services/informationService";
import customTestService from "@/services/customTestService";
import customMaterialService from "@/services/customMaterialService";
import chatBotService from "@/services/chatBotService";
import ChatMessageComponent from "./ChatMessageComponent.vue";
import CreateMaterial from "@/components/botpie-assistant/CreateMaterial";
import ApplicationComponent from "@/components/botpie-assistant/ApplicationComponent";
import PremiumViewComponent from "@/components/botpie-assistant/PremiumViewComponent";
import assistedMaterialService from "@/services/assistedMaterialService";
import TextMessageComponent from "./TextMessageComponent.vue";
import ExistingMaterialsList from "./ExistingMaterialsList.vue";
import ExistingMaterialViewer from "./ExistingMaterialViewer.vue";
import MaterialActions from "./MaterialActions.vue";
import MaterialScoreInput from "./MaterialScoreInput.vue";
import MaterialFinalStep from "./MaterialFinalStep.vue";
import MissionsView from "@/components/utopie/miscellaneous/MissionsView";
import { MEETING_OPTION, meetingQuestion } from "./meetingOffer";
import { REFERRAL_OPTIONS, referralQuestions } from "./referralOffer";
import { ensureReferralRewards } from "./referralRewards";
import { usesLine, usesCardClass, spendsUses } from "./serviceUses";
import { skipAutoScroll } from "./chatScroll";
const SERVICE = "materials";
import MaterialApplicationStep from "./MaterialApplicationStep.vue";
// import materialDocumentSocket from "@/mixins/materialDocumentSocket";

export default {
  components: {
    ChatMessageComponent,
    CreateMaterial,
    MissionsView,
    MaterialApplicationStep,
  },
  name: "ChatBotMaterials",
  // mixins: [materialDocumentSocket],
  data() {
    return {
      mainColor: "#e84855",
      secondaryColor: "#e48692",
      currentQuestionIndex: "welcomeMessage",
      context: { service: "Pruebas Informales"},
      // The interaction component sits above this chat; don't autoscroll to the
      // chat (stealing focus) until the user actually engages with it.
      hasInteracted: false,
      answers: {},
      selectedCard: null,
      messages: [],
      prices: {},
      cost: 0,
      appleIcon: require("@/assets/img/icono-manzana.svg"),
      starIcon: require("@/assets/img/icono-estrella.svg"),
      copyIcon: require("@/assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_link.svg"),
      backIcon: require("@/assets/img/eureka_icons/eureka_svg_icons/Íconos_atrás.svg"),
      reviewIcon: require("@/assets/img/eureka_icons/eureka_svg_icons/Ajustados sin fondo_revisar.svg"),

      types: ["text", "button", "quickReplies"],
      questions: {},
    };
  },
  created() {
    // Se pregunta acá, al montar, y no cuando la persona abre el referido: el
    // guard que decide si el referido se ofrece (`referralRewardsKnownEmpty`)
    // sólo se enteraba dentro de la vista de invitar, o sea después del clic
    // que queremos evitar. Es idempotente por servicio y falla abierto.
    ensureReferralRewards(SERVICE);
    this.questions = {
      action: {
        name: "action",
        text: "¡Hola! Soy tu asistente virtual. ¿En qué puedo ayudarte hoy?",
        type: "options",
        single_choice: true,
        nextQuestionIndex() {
          return "grade";
        },
        getAnswers() {
          if (!this.answersLoaded) {
            return new Promise((resolve) => {
              resolve(this.answers);
            });
          } else {
            return Promise.resolve(this.answers);
          }
        },
        routine() {
          console.log("routine");
          // this.currentQuestionIndex = this.nextQuestionIndex;
        },
        answers: [
          {
            name: "Crear material",
            value: 1,
            isSelected: false,
            nextQuestionIndex: "grade",
          },
          {
            name: "Aplicar material",
            value: 1,
            isSelected: false,
            nextQuestionIndex: "application",
          },
        ],
      },
      welcomeMessage: {
        name: "welcomeMessage",
        text: `¡Hola ${this.$store.state.login.first_name}! Los Materiales Interactivos son evaluaciones y actividades digitales para tus estudiantes,
              alineados al currículum chileno y al Programa de Integración Escolar.<br/>
              ${usesLine(SERVICE)}<br/>
              <strong>¿Qué te gustaría hacer?</strong>`,
        type: "options",
        answersLoaded: false,
        single_choice: true,
        answers: [],
        alreadySeen: [],
        process_dic: [
          // {
          //   label: "Conocer más detalles",
          //   nextIndex: "details",
          // },
          // {
          //   label: "Ver el tutorial",
          //   nextIndex: "learn",
          // },
          {
            label: "Recibir una cotización para mi colegio",
            nextIndex: "bill",
          },
          // {
          //   label: "Ocupar aplicaciones disponibles",
          //   nextIndex: "application_choice",
          // },
          // Las formas de conseguir usos van en este orden a propósito:
          // invitar primero (es la que más usos reparte y trae gente nueva),
          // luego declarar quién te invitó, y después el resto.
          ...REFERRAL_OPTIONS,
          {
            label: "Comprar usos",
            redirect: "/utopie#/buy_product/materials",
          },
          {
            label: "Ver misiones y ganar usos",
            nextIndex: "missions",
          },
          MEETING_OPTION,
        ],
        getAnswers() {
          if (!this.answersLoaded) {
            return new Promise((resolve) => {
              this.process_dic.forEach((ans) => {
                if (ans.condition) {
                  if (ans.condition()) {
                    this.answers.push({
                      name: ans.label,
                      isSelected: false,
                      class: "col-md-7 col-12 my-2",
                      bootstrap_classes: "text-left px-2 font-weight-bold",
                      nextQuestionIndex: ans.nextIndex,
                      redirect: ans.redirect,
                      cardClass: usesCardClass(ans, SERVICE),
                    });
                  }
                } else {
                  this.answers.push({
                    name: ans.label,
                    isSelected: false,
                    class: "col-md-7 col-12 my-2",
                    bootstrap_classes: "text-left px-2 font-weight-bold",
                    nextQuestionIndex: ans.nextIndex,
                    redirect: ans.redirect,
                    cardClass: usesCardClass(ans, SERVICE),
                  });
                }
              });
              this.answersLoaded = true;
              resolve(this.answers);
            });
          } else {
            return Promise.resolve(this.answers);
          }
        },
        routine() {
          console.log("routine");
        },
      },
      mainMessage: {
        name: "mainMessage",
        text() {
          if (!this.answers.length) {
            return "Has visto todos los mensajes disponibles! Recarga la página para comenzar de nuevo.";
          }
          return `${usesLine(SERVICE)}<br/>
                Ahora, <strong>¿Qué quieres hacer?</strong>`;
        },
        type: "options",
        answersLoaded: false,
        single_choice: true,
        isMain: true,
        answers: [],
        alreadySeen: [],
        process_dic: [
          // {
          //   label: "Conocer más detalles",
          //   nextIndex: "details",
          // },
          // {
          //   label: "Ver el tutorial",
          //   nextIndex: "learn",
          // },
          {
            label: "Recibir una cotización para mi colegio",
            nextIndex: "bill",
          },
          // {
          //   label: "Ocupar aplicaciones disponibles",
          //   nextIndex: "application_choice",
          // },
          // Las formas de conseguir usos van en este orden a propósito:
          // invitar primero (es la que más usos reparte y trae gente nueva),
          // luego declarar quién te invitó, y después el resto.
          ...REFERRAL_OPTIONS,
          {
            label: "Comprar usos",
            redirect: "/utopie#/buy_product/materials",
          },
          {
            label: "Ver misiones y ganar usos",
            nextIndex: "missions",
          },
          MEETING_OPTION,
          {
            label: "Reiniciar chat",
            nextIndex: "reset",
          },
        ],
        getAnswers(context) {
          this.answers = [];
          return new Promise((resolve) => {
            this.process_dic.forEach((ans) => {
              // Ya usada = ya leída: no se vuelve a ofrecer. La única que
              // repite es la acción del servicio.
              if (!(ans.nextIndex in context) || spendsUses(ans)) {
                if (ans.condition) {
                  if (ans.condition()) {
                    this.answers.push({
                      name: ans.label,
                      isSelected: false,
                      class: "col-md-7 col-12 my-2",
                      bootstrap_classes: "text-left px-2 font-weight-bold",
                      nextQuestionIndex: ans.nextIndex,
                      redirect: ans.redirect,
                      cardClass: usesCardClass(ans, SERVICE),
                    });
                  }
                } else {
                  this.answers.push({
                    name: ans.label,
                    isSelected: false,
                    class: "col-md-7 col-12 my-2",
                    bootstrap_classes: "text-left px-2 font-weight-bold",
                    nextQuestionIndex: ans.nextIndex,
                    redirect: ans.redirect,
                    cardClass: usesCardClass(ans, SERVICE),
                  });
                }
              }
            });
            this.answersLoaded = true;
            resolve(this.answers);
          });
        },
        routine() {
          console.log("routine");
        },
      },
      details: {
        name: "details",
        text: "¡Perfecto! Aquí te muestro los detalles de los Materiales Interactivos",
        type: "informative",
        nextQuestionIndex: "mainMessage",
        answers: [],
        process_dic: [
          {
            title: "Materiales interactivos para tus estudiantes",
            text: "Crea actividades digitales atractivas y dinámicas para evaluar y reforzar los aprendizajes desde Pre-kinder hasta 4° medio.",
            image: require("@/assets/img/material_icons/materiales_interactivos_icon.svg"),
            height: "300",
          },
          {
            title: "Alineados al currículum chileno",
            text: "Cada material se vincula a los Objetivos de Aprendizaje (OA) del MINEDUC en Lenguaje, Matemáticas y otras asignaturas.",
            image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_4.png"),
            height: "300",
          },
          {
            title: "Distintos tipos de pregunta",
            text: "Alternativas, ordenamiento, audio, dictados, ejercicios y respuestas de desarrollo, todo en un mismo material.",
            image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_7.png"),
            height: "300",
            cellHeight: "150",
          },
          {
            title: "Generación asistida por IA",
            text: "Crea novelas, fábulas, poemas, cartas, biografías y otros textos automáticamente para acompañar las preguntas del material.",
            image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_2.png"),
            height: "300",
          },
          {
            title: "Vitrina de materiales premium",
            text: "Accede a un catálogo de materiales listos para aplicar, creados por nuestro equipo educativo.",
            image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_10.png"),
            height: "300",
            cellHeight: "150",
          },
          {
            title: "Aplicación digital y revisión en línea",
            text: "Los estudiantes responden desde un computador y la mayoría de las preguntas se corrigen automáticamente.",
            image: require("@/assets/img/eureka_chatbot_icons/eureka_icon_6.png"),
            height: "300",
          },
        ],
        getAnswers() {
          if (!this.answersLoaded) {
            return new Promise((resolve) => {
              this.process_dic.forEach((ans) => {
                this.answers.push({
                  title: ans.title,
                  text: ans.text,
                  image: ans.image,
                  height: ans.height,
                  cellHeight: ans.cellHeight,
                  class: "col-12 col-md-12 mb-2",
                });
              });
              this.answersLoaded = true;
              resolve(this.answers);
            });
          } else {
            return Promise.resolve(this.answers);
          }
        },
        routine() {
          console.log("routine");
        },
      },
      learn: {
        name: "learn",
        text: "¡Genial! Mira el tutorial para conocer cómo funcionan los Materiales Interactivos. Cuando lo termines puedes continuar:",
        type: "informative",
        nextQuestionIndex: "mainMessage",
        answers: [],
        process_dic: [
          {
            text() {
              return "Recomendamos ver el video hasta el final antes de continuar";
            },
            video: "https://www.youtube.com/embed/V7868MKYvz8",
          },
        ],
        getAnswers() {
          if (!this.answersLoaded) {
            return new Promise((resolve) => {
              this.process_dic.forEach((ans) => {
                this.answers.push({
                  text: ans.text(),
                  video: ans.video,
                  class: "col-12 col-md-12 mb-2",
                });
              });
              this.answersLoaded = true;
              resolve(this.answers);
            });
          } else {
            return Promise.resolve(this.answers);
          }
        },
        routine() {
          console.log("routine");
        },
      },
      bill: {
        name: "bill",
        text: "¡Excelente! Indícanos tu correo y la cantidad de aplicaciones a cotizar y te enviaremos la cotización.",
        type: "inputs",
        answersLoaded: true,
        answers: [
          {
            name: "email",
            type: "email",
            placeholder: "Escribe tu correo aquí",
            class: "col-12 col-md-6 mb-2",
          },
          {
            name: "applications",
            type: "number",
            placeholder: "Cantidad de aplicaciones",
            class: "col-12 col-md-6 mb-2",
          },
        ],
        nextMessage: "Obtener cotización!",
        extraFunction: (data) => {
          informationService
            .sendEurekaBill({
              email: data.email,
              applications: data.applications,
              service: "MATERIAL",
            })
            .then((resp) => {
              this.$toasted.success(resp.message);
            });
        },
        nextQuestionIndex: "mainMessage",
        routine: () => {},
      },
      meeting: meetingQuestion(),
      ...referralQuestions(this, "mainMessage", SERVICE),
      missions: {
        name: "missions",
        text: () => {
          return `<div class="text-left"><strong>Puedes conseguir usos gratis realizando las siguientes acciones!</strong>`;
        },
        type: "custom-component",
        answersLoaded: true,
        answers: [],
        component: MissionsView,
        dontShowNextButton: true,
        nextQuestionIndex: "mainMessage",
        routine: () => {},
      },
      // "Ocupar aplicaciones disponibles" entry: choose between correcting an
      // existing specialty test or generating one with AI. The component drives
      // the whole correct-existing flow internally and emits go-to-step
      // ("score_input" to correct, or "grade" for the AI generation flow).
      application_choice: {
        name: "application_choice",
        text: "¿Qué te gustaría hacer con las aplicaciones disponibles?",
        type: "custom-component",
        component: MaterialApplicationStep,
        answersLoaded: false,
        answers: [],
        isFinal: false,
        dontShowNextButton: true,
        nextQuestionIndex: "mainMessage",
        routine() {},
        getAnswers() {
          return new Promise((resolve) => {
            resolve([]);
          });
        },
      },
      grade: {
        name: "grade",
        text: `!Hola ${this.$store.state.login.first_name}! Hagamos una un material interactivo. <br> Dime ¿Con qué curso quieres comenzar?`,
        hint: "Escoge solo un curso",
        type: "options",

        answersLoaded: false,
        single_choice: true,
        nextQuestionIndex: "material_type",
        answers: [],
        process_dic: {
          "Pre-kinder": "PK",
          Kinder: "K",
          "1° básico": "1°",
          "2° básico": "2°",
          "3° básico": "3°",
          "4° básico": "4°",
          "5° básico": "5°",
          "6° básico": "6°",
          "7° básico": "7°",
          "8° básico": "8°",
          "1° medio": "1°M",
          "2° medio": "2°M",
          "3° medio": "3°M",
          "4° medio": "4°M",
        },
        getAnswers() {
          if (!this.answersLoaded) {
            return new Promise((resolve, reject) => {
              informationService
                .getPieGrades()
                .then((data) => {
                  data["grades"]
                    .filter((g) => ![14, 15, 16].includes(g[0]))
                    .forEach((ans) => {
                      this.answers.push({
                        original_name: ans[1],
                        name: this.process_dic[ans[1]],
                        code: ans[0],
                        isSelected: false,
                        class: "col-sm-2 col-3 pr-1 pl-0 pb-1",
                        bootstrap_classes: "font-weight-bold",
                        nextQuestionIndex: "material_type",
                      });
                    });
                  this.answersLoaded = false;
                  resolve(this.answers);
                })
                .catch((error) => {
                  reject(error);
                });
            });
          } else {
            return Promise.resolve(this.answers);
          }
        },
        routine() {
          console.log("routine");
          // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
          // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
        },
      },
      material_type: {
        name: "material_type",
        text: "¿Necesitas una Prueba de especialidad lista para aplicar o generar un material para una asignatura?",
        hint: "Escoge una opción",
        type: "options",
        single_choice: true,
        answersLoaded: true,
        nextQuestionIndex: "subject",
        answers: [
          {
            name: "Prueba lista de especialidad",
            isSelected: false,
            class: "col-6 pb-1",
            nextQuestionIndex: "subject",
          },
          {
            name: "Generar material para asignatura",
            isSelected: false,
            class: "col-6 pb-1",
            nextQuestionIndex: "subject",
          },
        ],
        getAnswers() {
          return Promise.resolve(this.answers);
        },
        routine() {
          console.log("routine material_type");
        },
      },
      subject: {
        name: "subject",
        text: "¡Muy bien! Ahora dime ¿Con qué asignatura?",
        hint: "Escoge solo una asignatura",
        type: "options",
        answersLoaded: false,
        nextQuestionIndex: "oa",
        answers: [],
        single_choice: true,
        process_dic: {
          "Lenguaje y comunicación / Lengua y Literatura": "Lenguaje",
          Matemáticas: "Matemáticas",
          // "Modelo ecológico funcional": "Modelo ecológico funcional",
          // Música: "Música"
        },
        getAnswers(context) {
          // Asignaturas que ofrecen "usar materiales existentes"
          const SPECIAL_SUBJECTS = ["Psicología", "Fonoaudiología", "Psicopedagogía"]; // , "Emocional sensorial y motriz", "Habilidades adaptativas"];
          const onlySpecial =
            context &&
            context.material_type &&
            context.material_type.name === "Prueba lista de especialidad";
          if (!this.answersLoaded) {
            return new Promise((resolve, reject) => {
              customTestService
                .getSubjectHashtags(context.grade.original_name)
                .then((data) => {
                  data
                    //.filter((s) => [7, 29, 61, 8, 4].includes(s[0]))
                    .forEach((ans) => {
                      const isSpecial = SPECIAL_SUBJECTS.includes(ans.name);
                      if (onlySpecial && !isSpecial) return;
                      if (!onlySpecial && isSpecial) return;
                      this.answers.push({
                        name: ans.name, // this.process_dic[ans[1]],
                        code: ans.id,
                        enum_code: ans.enum_code,
                        isSelected: false,
                        cols: "col-6",
                        // material_mode skipped: special subjects go straight
                        // to the existing-materials list, as if the user chose
                        // "Usar materiales existentes".
                        nextQuestionIndex: isSpecial
                          ? "existing_materials_list"
                          : "oa",
                        class: "pb-1",
                      });
                    });
                  this.answersLoaded = true;
                  resolve(this.answers);
                })
                .catch((error) => {
                  reject(error);
                });
              // informationService
              //   .getCardSubjectsValues()
              //   .then((data) => {
              //     data
              //       .filter((s) => [7, 29].includes(s[0]))
              //       .forEach((ans) => {
              //         this.answers.push({
              //           name: this.process_dic[ans[1]],
              //           code: ans[0],
              //           isSelected: false,
              //           class: "col-5 pr-1 pl-0 pb-1",
              //           nextQuestionIndex: "oa",
              //         });
              //       });
              //     resolve(this.answers);
              //   })
              //   .catch((error) => {
              //     reject(error);
              //   });
            });
          } else {
            return Promise.resolve(this.answers);
          }
        },
        routine() {
          console.log("routine");
          // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
          // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
        },
      },
      // material_mode question skipped: special subjects proceed as if the
      // user answered "Usar materiales existentes" (see subject.getAnswers,
      // where isSpecial now routes straight to existing_materials_list).
      // material_mode: {
      //   name: "material_mode",
      //   text: "¿Quieres usar un material existente o crear uno nuevo?",
      //   hint: "Escoge una opción",
      //   type: "options",
      //   single_choice: true,
      //   answersLoaded: true,
      //   answers: [
      //     {
      //       name: "Usar materiales existentes",
      //       isSelected: false,
      //       class: "col-6 pb-1",
      //       nextQuestionIndex: "existing_materials_list",
      //     },
      //     {
      //       name: "Crear nuevo material",
      //       isSelected: false,
      //       class: "col-6 pb-1",
      //       nextQuestionIndex: "oa",
      //     },
      //   ],
      //   nextQuestionIndex: "existing_materials_list",
      //   getAnswers() {
      //     return Promise.resolve(this.answers);
      //   },
      //   routine() {
      //     console.log("routine material_mode");
      //   },
      // },
      existing_materials_list: {
        name: "existing_materials_list",
        text: "Estos son los materiales disponibles. Selecciona uno para continuar.",
        type: "custom-component",
        component: ExistingMaterialsList,
        answersLoaded: false,
        answers: [],
        nextMessage: "Continuar",
        nextQuestionIndex: "material_action",
        routine() {
          console.log("routine existing_materials_list");
        },
        getAnswers() {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve([]);
            }, 1000);
          });
        },
      },
      existing_material_viewer: {
        name: "existing_material_viewer",
        text: "¡Listo! Aquí puedes ver el material. Usa las flechas para navegar entre niveles de cada eje.",
        type: "custom-component",
        component: ExistingMaterialViewer,
        answersLoaded: false,
        answers: [],
        isFinal: false,
        dontShowNextButton: true,
        nextMessage: "Finalizar",
        nextQuestionIndex: "ask_premium",
        routine() {
          console.log("routine existing_material_viewer");
        },
        getAnswers() {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve([]);
            }, 1000);
          });
        },
      },
      material_action: {
        name: "material_action",
        text: "¿Qué quieres hacer con este material?",
        type: "custom-component",
        component: MaterialActions,
        answersLoaded: false,
        answers: [],
        isFinal: false,
        dontShowNextButton: true,
        // Branching is driven by the component via $emit("go-to-step", ...);
        // "Descargar" performs a side-effect and stays on this step.
        nextQuestionIndex: "ask_premium",
        routine() {
          console.log("routine material_action");
        },
        getAnswers() {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve([]);
            }, 600);
          });
        },
      },
      score_input: {
        name: "score_input",
        text: "Ingresa los resultados de la aplicación para generar el informe.",
        type: "custom-component",
        component: MaterialScoreInput,
        answersLoaded: false,
        answers: [],
        isFinal: false,
        dontShowNextButton: true,
        nextQuestionIndex: "report_done",
        routine() {
          console.log("routine score_input");
        },
        getAnswers() {
          return new Promise((resolve) => {
            setTimeout(() => {
              resolve([]);
            }, 600);
          });
        },
      },
      report_done: {
        name: "report_done",
        text: "¡Listo! Tu informe se ha generado.",
        type: "custom-component",
        component: MaterialFinalStep,
        answersLoaded: true,
        answers: [],
        dontShowNextButton: true,
        nextQuestionIndex: "reset",
        routine() {},
        getAnswers() {
          return new Promise((resolve) => {
            resolve([]);
          });
        },
      },
      oa: {
        name: "oa",
        text: () => {
          const grade =
            this.$store.state.chatbot.conversation.grade.answer.original_name;
          const subject =
            this.$store.state.chatbot.conversation.subject.answer.name;
          return `Estos son los objetivos de aprendizaje de ${grade} para ${subject}<br> ¿Cuales te gustaría trabajar?`;
        },
        hint: () => {
          const starIcon = this.starIcon;
          return `Escoge tus objetivos de aprendizaje. <br> Los <img src='${starIcon}' width='22px' class='pl-1 mb-2'/></img> son basales`;
        },
        // type: "options",
        optionalCheckbox: true,
        // define de nuevo type, si optionalCheckbox es true, entonces type es options, si no, es options-counter
        type: "hybrid-options",
        optionalCheckboxText: "Activar Indicadores de Evaluación",
        optionalCheckboxDisabled: false,
        answersLoaded: false,
        answers: [],
        nextQuestionIndex: (context) => {
          if (context["oa"].optionalCheckbox) {
            return "indicadores";
          }
          if (
            context["subject"]["name"] ===
            "Lenguaje y comunicación / Lengua y Literatura"
          ) {
            return this.switchTextType(context["oa"].answers);
          } else {
            return "material";
          }
        },
        single_choice: false,
        getAnswers(context) {
          if (!this.answersLoaded) {
            return new Promise((resolve, reject) => {
              chatBotService
                .getPrice({ code: "OA" })
                .then((prices) => {
                  customTestService
                    .getTagsFiltered(context.subject.code)
                    .then((d) => {
                      if (d.length) {
                        if (!d[0].subtags.length) {
                          this.optionalCheckbox = false;
                          this.optionalCheckboxDisabled = true;
                        }
                      }
                      d.sort((a, b) => a.priority - b.priority).forEach(
                        (ans) => {
                          let short_name = ans.name.split(" ").slice(-1);
                          let text = ans.summary
                            ? ans.summary
                            : ans.description;
                          this.answers.push({
                            name:
                              "<strong style='font-size: 1.2rem;'>" +
                              short_name +
                              "</strong> - " +
                              text,
                            description: ans.description,
                            isSelected: false,
                            price: prices[0].price,
                            class: "col-sm-12 col-12",
                            subtags: ans.subtags,
                            count: 0,
                            bootstrap_classes: "text-left px-2",
                            priority: ans.priority,
                            id: ans.id,
                            full_name: ans.name,
                            has_warning: true,
                            warning_text:
                              "Debes tener al menos 3 actividades seleccionadas!",
                            required: 3,
                            key: "count",
                            resource_type_display: ans.resource_type_display,
                            ...(ans.resource_type && {
                              resource_type: ans.resource_type_display
                                .split("-")[0]
                                .trim(),
                              resource_type_detail: ans.resource_type_display
                                .split("-")[1]
                                .trim(),
                            }),
                          });
                        }
                      );
                      this.answersLoaded = true;
                      resolve(this.answers);
                    });
                })
                .catch((error) => {
                  reject(error);
                });
            });
          } else {
            return Promise.resolve(this.answers);
          }
        },

        routine() {
          console.log("routine");
          console.log(this.answers);
          // this.currentQuestionIndex = this.nextQuestionIndex;
          this.answers = this.answers.filter((ans) => {
            return ans.count > 0 || ans.isSelected;
          });
        },
        updateStore: (context) => {
          console.log("updateStore");
          console.log(context);
          // no activa indicadores
          if (!context["oa"].optionalCheckbox) {
            // group by resource_type_display
            const groupedQuestions = context["oa"].answers.reduce(
              (acc, ans) => {
                const resourceType = ans.resource_type_display;
                if (resourceType) {
                  if (!acc[resourceType]) {
                    acc[resourceType] = [];
                  }
                  acc[resourceType].push(ans);
                } else {
                  if (!acc["not-linked"]) {
                    acc["not-linked"] = [];
                  }
                  acc["not-linked"].push(ans);
                }
                return acc;
              },
              {}
            );

            this.$store.commit("chatbot/updateMessage", {
              name: "general",
              key: "questions",
              value: groupedQuestions,
            });
          }
        },
      },
      // audio slider
      text_topic: {
        name: "text_topic",
        text: () => {
          return `Algunos OAs seleccionados requieren de un texto de tipo multimedia. <br> Así que ¡Vamos a crearlo automáticamente! <br> Dime <strong>¿De qué se va a tratar?<strong/>`;
        },
        type: "options",
        single_choice: true,
        answersLoaded: true,
        answers: [
          {
            name: "Ciencia Ficción",
            value: 1,
            isSelected: false,
            nextQuestionIndex: "text_topic_details_slider",
          },
          {
            name: "Romance",
            value: 2,
            isSelected: false,
            nextQuestionIndex: "text_topic_details_slider",
          },
          {
            name: "Viaje",
            value: 3,
            isSelected: false,
            nextQuestionIndex: "text_topic_details_slider",
          },
        ],
        nextQuestionIndex: "text_topic_details_slider",
        routine() {
          console.log("routine");
          // this.currentQuestionIndex = this.nextQuestionIndex;
        },
        getAnswers() {
          if (!this.answersLoaded) {
            return new Promise((resolve) => {
              resolve(this.answers);
            });
          } else {
            return Promise.resolve(this.answers);
          }
        },
      },
      text_topic_details_slider: {
        name: "text_topic_details_slider",
        text: "¡Genial! puedes darme mas detalles sobre el texto",
        type: "text-area",
        answersLoaded: true,
        answers: [],
        optionalCheckbox: true,
        optionalCheckboxText:
          "Activar configuración personalizada <br> <span style='color: #757575; font-weight: normal;'>Podrás seleccionar: narrador, personajes, estilos, etc.</span>",
        nextQuestionIndex(context) {
          const optionalCheckbox =
            context["text_topic_details_slider"].optionalCheckbox;
          return optionalCheckbox ? "plot_options" : "validate_text_novela";
        },
        routine() {
          console.log("routine");
          // this.currentQuestionIndex = this.nextQuestionIndex;
        },
      },
      plot_options: {
        name: "plot_options",
        text: () => {
          return `¡Muy bien! Se me ocurren estas 3 tramas.`;
        },
        hint: "Escoge la que mas te guste",
        type: "options",
        answersLoaded: false,
        single_choice: true,
        answers: [
          {
            name: "",
            title: "",
            class: "col-12 px-0 pb-1",
            nextQuestionIndex: "characters_options",
            isSelected: false,
          },
          {
            name: "",
            title: "",
            class: "col-12 px-0 pb-1",
            nextQuestionIndex: "characters_options",
            isSelected: false,
          },
          {
            name: "",
            title: "",
            class: "col-12 px-0 pb-1",
            nextQuestionIndex: "characters_options",
            isSelected: false,
          },
        ],
        getAnswers(context) {
          if (!this.answersLoaded) {
            return new Promise((resolve, reject) => {
              // const objectContext = this;
              assistedMaterialService
                .generatePlots(
                  2,
                  3,
                  context["text_topic"]["value"],
                  context["text_topic_details_slider"]["textInput"]
                )
                .then((response) => {
                  response.forEach((item, index) => {
                    this.answers[index].name = item.name;
                    this.answers[index].title = item.title;
                  });
                  resolve(this.answers);
                })
                .catch((error) => {
                  console.log(error);
                  reject(error);
                });
            });
          } else {
            return Promise.resolve(this.answers);
          }
        },
        nextQuestionIndex: "characters_options",
        routine() {
          console.log("routine");
          // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
          // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
        },
      },
      characters_options: {
        name: "characters_options",
        text: () => {
          return `¡Muy bien! Se me ocurren estos personajes.`;
        },
        hint: "Escoge el que mas te guste",
        type: "options",
        answersLoaded: false,
        single_choice: true,
        answers: [
          {
            name: "",
            class: "col-12 px-0 pb-1 text-left",
            nextQuestionIndex: "final_settings",
            isSelected: false,
          },
          {
            name: "",
            class: "col-12 px-0 pb-1",
            nextQuestionIndex: "final_settings",
            isSelected: false,
          },
          {
            name: "",
            class: "col-12 px-0 pb-1",
            nextQuestionIndex: "final_settings",
            isSelected: false,
          },
        ],
        getAnswers(context) {
          if (!this.answersLoaded) {
            return new Promise((resolve) => {
              const objectContext = this;
              assistedMaterialService
                .generateCharacters(3, context.plot_options.name, 3)
                .then((response) => {
                  response
                    .filter((r) => r.name !== "")
                    .forEach((chars, index) => {
                      objectContext.answers[index].name += '<ol class="my-1">';
                      chars.forEach((item) => {
                        objectContext.answers[
                          index
                        ].name += `<li class="text-left">${item.name}: ${item.description} </li>`;
                      });
                      objectContext.answers[index].name += "</ol>";
                    });

                  resolve(this.answers);
                });
            }).catch((error) => {
              console.log(error);
            });
          } else {
            return Promise.resolve(this.answers);
          }
        },
        nextQuestionIndex: "final_settings",
        routine() {
          console.log("routine");
          // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
          // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
        },
      },
      final_settings: {
        name: "final_settings",
        text: () => {
          return `Estamos casi listos. <br> Ahora, algunos ajustes finales ...`;
        },
        type: "selector-options",
        answersLoaded: false,
        answers: [
          {
            name: "ajuste 1",
            class: "col-8 pb-2 px-0",
            options: [
              "Narrado en primera persona",
              "Narrado en tercera persona",
              "Narrador omnisciente",
            ],
            placeholder: "Selecciona el tipo de narrador",
            selected: "Narrado en tercera persona",
          },
          {
            name: "ajuste 2",
            class: "col-8 pb-2 px-0",
            options: ["Atmósfera de misterio y suspenso", "Cómico", "Acción"],
            placeholder: "Selecciona el tipo de atmósfera",
            selected: "Cómico",
          },
        ],
        getAnswers() {
          if (!this.answersLoaded) {
            return new Promise((resolve) => {
              resolve(this.answers);
            });
          } else {
            return Promise.resolve(this.answers);
          }
        },
        routine() {
          console.log("routine");
          // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
          // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
        },
        nextQuestionIndex: "validate_text_slider",
      },
      validate_text_slider: {
        name: "validate_text_slider",
        text: () => {
          // const contentType = this.$store.state.chatbot.conversation
          //   .final_settings
          //   ? this.$store.state.chatbot.conversation.final_settings.answers[2]
          //       .selected.name
          //   : this.questions.final_settings.answers[2].selected.name;
          return "¡Perfecto, en menos de 1 minutos tendremos tu historia lista!";
        },
        type: "custom-component",
        nextMessage: "¡Listo! Guardar texto",
        component: TextMessageComponent,
        answersLoaded: false,
        loadingType: "progress-bar",
        loadingMax: 90, // seconds,
        nextQuestionIndex: (context) => {
          const hasNovela = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Novela"
          );
          const hasFabula = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Fábula"
          );
          const hasPoema = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Poema"
          );
          const hasNoticia = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Noticia"
          );
          const hasCarta = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Carta"
          );
          const hasBiografia = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Biografía"
          );
          const hasExpositivo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Expositivo"
          );
          const hasEnsayo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Ensayo"
          );
          if (hasNovela) {
            return "text_topic_details_novela";
          } else if (hasFabula) {
            return "text_topic_details_fabula";
          } else if (hasPoema) {
            return "text_topic_details_poema";
          } else if (hasNoticia) {
            return "text_topic_details_noticia";
          } else if (hasCarta) {
            return "text_topic_details_carta";
          } else if (hasBiografia) {
            return "text_topic_details_biografia";
          } else if (hasExpositivo) {
            return "text_topic_details_expositivo";
          } else if (hasEnsayo) {
            return "text_topic_details_ensayo";
          } else {
            return "material";
          }
        },
        routine: () => {
          // const contentType = this.$store.state.chatbot.conversation
          //   .final_settings
          //   ? this.$store.state.chatbot.conversation.final_settings.answers[2]
          //       .selected.name
          //   : this.questions.final_settings.answers[2].selected.name;
          const type = 1;

          if (type == 0) {
            assistedMaterialService
              .saveText({
                title:
                  this.$store.state.chatbot.conversation.validate_text_novela
                    .createdText.title,
                text: this.$store.state.chatbot.conversation
                  .validate_text_novela.createdText.content,
                school: this.$store.state.login.school,
                text_type: 3,
              })
              .then((response) => {
                this.$store.commit("chatbot/updateMessage", {
                  name: "validate_text_novela",
                  key: "createdText",
                  value: response,
                });
                console.log("response");
                console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          }

          // let selectedAnswer = this.answers.find((ans) => ans.isSelected);
          // this.currentQuestionIndex = selectedAnswer.nextQuestionIndex;
        },
      },
      // novela
      text_topic_details_novela: {
        name: "text_topic_details_novela",
        text: "¡Genial! puedes darme mas detalles sobre la novela",
        type: "text-area",
        answersLoaded: true,
        answers: [],
        nextQuestionIndex() {
          return "validate_text_novela";
        },
        routine() {
          console.log("routine");
          // this.currentQuestionIndex = this.nextQuestionIndex;
        },
      },
      validate_text_novela: {
        name: "validate_text_novela",
        text: () => {
          return `¡Perfecto, en menos de 1 minutos tendremos tu historia lista!`;
        },
        type: "custom-component",
        nextMessage: "¡Listo! Guardar texto",
        component: TextMessageComponent,
        answersLoaded: false,
        loadingType: "progress-bar",
        loadingMax: 90, // seconds,
        nextQuestionIndex: (context) => {
          const hasFabula = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Fábula"
          );
          const hasPoema = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Poema"
          );
          const hasNoticia = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Noticia"
          );
          const hasCarta = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Carta"
          );
          const hasBiografia = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Biografía"
          );
          const hasExpositivo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Expositivo"
          );
          const hasEnsayo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Ensayo"
          );
          if (hasFabula) {
            return "text_topic_details_fabula";
          } else if (hasPoema) {
            return "text_topic_details_poema";
          } else if (hasNoticia) {
            return "text_topic_details_noticia";
          } else if (hasCarta) {
            return "text_topic_details_carta";
          } else if (hasBiografia) {
            return "text_topic_details_biografia";
          } else if (hasExpositivo) {
            return "text_topic_details_expositivo";
          } else if (hasEnsayo) {
            return "text_topic_details_ensayo";
          } else {
            return "material";
          }
        },
        routine: () => {
          assistedMaterialService
            .saveText({
              title:
                this.$store.state.chatbot.conversation.validate_text_novela
                  .createdText.title,
              text: this.$store.state.chatbot.conversation.validate_text_novela
                .createdText.content,
              school: this.$store.state.login.school,
              text_type: 3,
            })
            .then((response) => {
              this.$store.commit("chatbot/updateMessage", {
                name: "validate_text_novela",
                key: "createdText",
                value: response,
              });
              console.log("response");
              console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        },
      },
      // fabula
      text_topic_details_fabula: {
        name: "text_topic_details_fabula",
        text: "Alguno de los OAs seleccionados requieren de una fábula ¿de qué se va a tratar?",
        type: "text-area",
        answersLoaded: true,
        answers: [],
        nextQuestionIndex() {
          return "validate_text_fabula";
        },
        routine() {
          console.log("routine");
          // this.currentQuestionIndex = this.nextQuestionIndex;
        },
      },
      validate_text_fabula: {
        name: "validate_text_fabula",
        text: () => {
          return `¡Perfecto, en menos de 1 minutos tendremos tu historia lista!`;
        },
        type: "custom-component",
        nextMessage: "¡Listo! Guardar texto",
        component: TextMessageComponent,
        answersLoaded: false,
        loadingType: "progress-bar",
        loadingMax: 90, // seconds,
        nextQuestionIndex: (context) => {
          const hasPoema = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Poema"
          );
          const hasNoticia = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Noticia"
          );
          const hasCarta = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Carta"
          );
          const hasBiografia = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Biografía"
          );
          const hasExpositivo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Expositivo"
          );
          const hasEnsayo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Ensayo"
          );
          if (hasPoema) {
            return "text_topic_details_poema";
          } else if (hasNoticia) {
            return "text_topic_details_noticia";
          } else if (hasCarta) {
            return "text_topic_details_carta";
          } else if (hasBiografia) {
            return "text_topic_details_biografia";
          } else if (hasExpositivo) {
            return "text_topic_details_expositivo";
          } else if (hasEnsayo) {
            return "text_topic_details_ensayo";
          } else {
            return "material";
          }
        },
        routine: () => {
          assistedMaterialService
            .saveText({
              title:
                this.$store.state.chatbot.conversation.validate_text_fabula
                  .createdText.title,
              text: this.$store.state.chatbot.conversation.validate_text_fabula
                .createdText.content,
              school: this.$store.state.login.school,
              text_type: 1,
            })
            .then((response) => {
              this.$store.commit("chatbot/updateMessage", {
                name: "validate_text_fabula",
                key: "createdText",
                value: response,
              });
              console.log("response");
              console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        },
      },
      // poema
      text_topic_details_poema: {
        name: "text_topic_details_poema",
        text: "!Genial! Hay objetivos de aprendizajes que requieren un poema. <br> ¿De qué se va a tratar?",
        type: "text-area",
        answersLoaded: true,
        answers: [],
        nextQuestionIndex() {
          return "validate_text_poema";
        },
        routine() {
          console.log("routine");
          // this.currentQuestionIndex = this.nextQuestionIndex;
        },
      },
      validate_text_poema: {
        name: "validate_text_poema",
        text: () => {
          return `¡Perfecto, en menos de 1 minutos tendremos tu historia lista!`;
        },
        type: "custom-component",
        nextMessage: "¡Listo! Guardar texto",
        component: TextMessageComponent,
        answersLoaded: false,
        loadingType: "progress-bar",
        loadingMax: 90, // seconds,
        nextQuestionIndex: (context) => {
          const hasNoticia = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Noticia"
          );
          const hasCarta = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Carta"
          );
          const hasBiografia = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Biografía"
          );
          const hasExpositivo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Expositivo"
          );
          const hasEnsayo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Ensayo"
          );
          if (hasNoticia) {
            return "text_topic_details_noticia";
          } else if (hasCarta) {
            return "text_topic_details_carta";
          } else if (hasBiografia) {
            return "text_topic_details_biografia";
          } else if (hasExpositivo) {
            return "text_topic_details_expositivo";
          } else if (hasEnsayo) {
            return "text_topic_details_ensayo";
          } else {
            return "material";
          }
        },
        routine: () => {
          assistedMaterialService
            .saveText({
              title:
                this.$store.state.chatbot.conversation.validate_text_poema
                  .createdText.title,
              text: this.$store.state.chatbot.conversation.validate_text_poema
                .createdText.content,
              school: this.$store.state.login.school,
              text_type: 2,
            })
            .then((response) => {
              this.$store.commit("chatbot/updateMessage", {
                name: "validate_text_poema",
                key: "createdText",
                value: response,
              });
              console.log("response");
              console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        },
      },
      // noticia
      text_topic_details_noticia: {
        name: "text_topic_details_noticia",
        text: "¡Genial! puedes darme mas detalles sobre la noticia",
        type: "text-area",
        answersLoaded: true,
        answers: [],
        nextQuestionIndex() {
          return "validate_text_noticia";
        },
        routine() {
          console.log("routine");
          // this.currentQuestionIndex = this.nextQuestionIndex;
        },
      },
      validate_text_noticia: {
        name: "validate_text_noticia",
        text: () => {
          return `¡Perfecto, en menos de 1 minutos tendremos tu historia lista!`;
        },
        type: "custom-component",
        nextMessage: "¡Listo! Guardar texto",
        component: TextMessageComponent,
        answersLoaded: false,
        loadingType: "progress-bar",
        loadingMax: 90, // seconds,
        nextQuestionIndex: (context) => {
          const hasCarta = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Carta"
          );
          const hasBiografia = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Biografía"
          );
          const hasExpositivo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Expositivo"
          );
          const hasEnsayo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Ensayo"
          );
          if (hasCarta) {
            return "text_topic_details_carta";
          } else if (hasBiografia) {
            return "text_topic_details_biografia";
          } else if (hasExpositivo) {
            return "text_topic_details_expositivo";
          } else if (hasEnsayo) {
            return "text_topic_details_ensayo";
          } else {
            return "material";
          }
        },
        routine: () => {
          assistedMaterialService
            .saveText({
              title:
                this.$store.state.chatbot.conversation.validate_text_noticia
                  .createdText.title,
              text: this.$store.state.chatbot.conversation.validate_text_noticia
                .createdText.content,
              school: this.$store.state.login.school,
              text_type: 4,
            })
            .then((response) => {
              this.$store.commit("chatbot/updateMessage", {
                name: "validate_text_noticia",
                key: "createdText",
                value: response,
              });
              console.log("response");
              console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        },
      },
      // carta
      text_topic_details_carta: {
        name: "text_topic_details_carta",
        text: "¡Genial! Hay OAs que requieren de una carta, ¿De qué se va a tratar?",
        type: "text-area",
        answersLoaded: true,
        answers: [],
        nextQuestionIndex() {
          return "validate_text_carta";
        },
        routine() {
          console.log("routine");
          // this.currentQuestionIndex = this.nextQuestionIndex;
        },
      },
      validate_text_carta: {
        name: "validate_text_carta",
        text: () => {
          return `¡Perfecto, en menos de 1 minutos tendremos tu historia lista!`;
        },
        type: "custom-component",
        nextMessage: "¡Listo! Guardar texto",
        component: TextMessageComponent,
        answersLoaded: false,
        loadingType: "progress-bar",
        loadingMax: 90, // seconds,
        nextQuestionIndex: (context) => {
          const hasBiografia = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Biografía"
          );
          const hasExpositivo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Expositivo"
          );
          const hasEnsayo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Ensayo"
          );

          if (hasBiografia) {
            return "text_topic_details_biografia";
          } else if (hasExpositivo) {
            return "text_topic_details_expositivo";
          } else if (hasEnsayo) {
            return "text_topic_details_ensayo";
          } else {
            return "material";
          }
        },
        routine: () => {
          assistedMaterialService
            .saveText({
              title:
                this.$store.state.chatbot.conversation.validate_text_carta
                  .createdText.title,
              text: this.$store.state.chatbot.conversation.validate_text_carta
                .createdText.content,
              school: this.$store.state.login.school,
              text_type: 5,
            })
            .then((response) => {
              this.$store.commit("chatbot/updateMessage", {
                name: "validate_text_carta",
                key: "createdText",
                value: response,
              });
              console.log("response");
              console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        },
      },
      // biografia
      text_topic_details_biografia: {
        name: "text_topic_details_biografia",
        text: "¡Genial! puedes darme mas detalles sobre la biografía",
        type: "text-area",
        answersLoaded: true,
        answers: [],
        nextQuestionIndex() {
          return "validate_text_biografia";
        },
        routine() {
          console.log("routine");
          // this.currentQuestionIndex = this.nextQuestionIndex;
        },
      },
      validate_text_biografia: {
        name: "validate_text_biografia",
        text: () => {
          return `¡Perfecto, en menos de 1 minutos tendremos tu historia lista!`;
        },
        type: "custom-component",
        nextMessage: "¡Listo! Guardar texto",
        component: TextMessageComponent,
        answersLoaded: false,
        loadingType: "progress-bar",
        loadingMax: 90, // seconds,
        nextQuestionIndex: (context) => {
          const hasExpositivo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Expositivo"
          );
          const hasEnsayo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Ensayo"
          );

          if (hasExpositivo) {
            return "text_topic_details_expositivo";
          } else if (hasEnsayo) {
            return "text_topic_details_ensayo";
          } else {
            return "material";
          }
        },
        routine: () => {
          assistedMaterialService
            .saveText({
              title:
                this.$store.state.chatbot.conversation.validate_text_biografia
                  .createdText.title,
              text: this.$store.state.chatbot.conversation
                .validate_text_biografia.createdText.content,
              school: this.$store.state.login.school,
            })
            .then((response) => {
              this.$store.commit("chatbot/updateMessage", {
                name: "validate_text_biografia",
                key: "createdText",
                value: response,
              });
              console.log("response");
              console.log(response);
            })
            .catch((error) => {
              console.log(error);
            });
        },
      },
      // expositivo
      text_topic_details_expositivo: {
        name: "text_topic_details_expositivo",
        text: "Genial! puedes darme mas detalles sobre el texto expositivo",
        type: "text-area",
        answersLoaded: true,
        answers: [],
        nextQuestionIndex() {
          return "validate_text_expositivo";
        },
        routine() {
          console.log("routine");
          // this.currentQuestionIndex = this.nextQuestionIndex;
        },
      },
      validate_text_expositivo: {
        name: "validate_text_expositivo",
        text: () => {
          return `¡Perfecto, en menos de 1 minutos tendremos tu historia lista!`;
        },
        type: "custom-component",
        nextMessage: "¡Listo! Guardar texto",
        component: TextMessageComponent,
        answersLoaded: false,
        loadingType: "progress-bar",
        loadingMax: 90, // seconds,
        nextQuestionIndex: (context) => {
          const hasEnsayo = context["oa"].answers.some(
            (ans) =>
              ans.resource_type === "Text" &&
              ans.resource_type_detail === "Ensayo"
          );

            if (hasEnsayo) {
              return "text_topic_details_ensayo";
            } else {
              return "material";
            }

          },
          routine: () => {
            assistedMaterialService
              .saveText({
                title:
                  this.$store.state.chatbot.conversation.validate_text_expositivo
                    .createdText.title,
                text: this.$store.state.chatbot.conversation.validate_text_expositivo
                  .createdText.content,
                school: this.$store.state.login.school,
              })
              .then((response) => {
                this.$store.commit("chatbot/updateMessage", {
                  name: "validate_text_expositivo",
                  key: "createdText",
                  value: response,
                });
                console.log("response");
                console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          },
        },
        // ensayo
        text_topic_details_ensayo: {
          name: "text_topic_details_ensayo",
          text: "Genial! puedes darme mas detalles sobre el ensayo",
          type: "text-area",
          answersLoaded: true,
          answers: [],
          nextQuestionIndex() {
            return "validate_text_ensayo";
          },
          routine() {
            console.log("routine");
            // this.currentQuestionIndex = this.nextQuestionIndex;
          },
        },
        validate_text_ensayo: {
          name: "validate_text_ensayo",
          text: () => {
            return `¡Perfecto, en menos de 1 minutos tendremos tu historia lista!`;
          },
          type: "custom-component",
          nextMessage: "¡Listo! Guardar texto",
          component: TextMessageComponent,
          answersLoaded: false,
          loadingType: "progress-bar",
          loadingMax: 90, // seconds,
          nextQuestionIndex: "material",
          routine: () => {
            assistedMaterialService
              .saveText({
                title:
                  this.$store.state.chatbot.conversation.validate_text_ensayo
                    .createdText.title,
                text: this.$store.state.chatbot.conversation.validate_text_ensayo
                  .createdText.content,
                school: this.$store.state.login.school,
              })
              .then((response) => {
                this.$store.commit("chatbot/updateMessage", {
                  name: "validate_text_ensayo",
                  key: "createdText",
                  value: response,
                });
                console.log("response");
                console.log(response);
              })
              .catch((error) => {
                console.log(error);
              });
          },
        },
         // indicadores
        indicadores: {
          name: "indicadores",
          text: "Ahora, selecciona la cantidad de actividades.", // por indicador de evaluación.",
          hint: () => {
            return "";
            // const appleIcon = this.appleIcon;
            // return `Cada indicador cuesta 100 <img src='${appleIcon}' width='22px' class='pl-1 mb-2'/></img>`;
          },
          type: "options-counter",
          answersLoaded: true,
          nextQuestionIndex: (context) => {            
            if (context["subject"]["name"] ===
              "Lenguaje y comunicación / Lengua y Literatura") {
              return this.switchTextType(context["oa"].answers);
            } else {
              return "material";
            }
          },
          answers: [],
          getAnswers(context) {
            return new Promise((resolve) => {
              return chatBotService.getPrice({ code: "IND" }).then((prices) => {
                context.oa.answers.forEach((ans) => {
                  let indicators = ans.subtags
                    .filter((s) => s.summary != null)
                    .map((i, index) => {
                      return {
                        name: `Ind. ${index + 1}: ${i.summary}`,
                        count: 0,
                        description: i.name,
                        price: prices[0].price,
                        id: i.id,
                      };
                    });
                  this.answers.push({
                    name_section: ans.name,
                    has_warning: true,
                    warning_text:
                      "Debes tener al menos 3 actividades seleccionadas por OA!",
                    key: "oaInds",
                    required: 3,
                    options: indicators,
                    class: "col-12",
                    oaInds: 0,
                    description: ans.description,
                    name: ans.full_name,
                    id: ans.id,
                    resource_type: ans.resource_type,
                    resource_type_display: ans.resource_type_display,
                    resource_type_detail: ans.resource_type_detail,
                  });
                });
                resolve(this.answers);
              });
            });
          },
          routine() {
            // let selectedAnswer = this.currentQuestion.answers.find(
            //   (ans) => ans.isSelected
            // );

          // iterar en answers y por cada answer iterar en options y eliminar los que tengan count 0 y también eliminar las answer con options vacíos

          this.answers.map((ans) => {
            ans.options = ans.options.filter((opt) => opt.count > 0);
            return ans.options.length > 0;
          });
        },
        updateStore: (context) => {
          console.log("updateStore");
          console.log(context);

          // no activa indicadores
          const groupedQuestions = context["indicadores"].reduce((acc, ans) => {
            const resourceType = ans.resource_type_display;
            if (resourceType) {
              if (!acc[resourceType]) {
                acc[resourceType] = [];
              }
              acc[resourceType].push(ans);
            } else {
              if (!acc["not-linked"]) {
                acc["not-linked"] = [];
              }
              acc["not-linked"].push(ans);
            }
            return acc;
          }, {});

          this.$store.commit("chatbot/updateMessage", {
            name: "general",
            key: "questions",
            value: groupedQuestions,
          });
          console.log("groupedQuestions");
          console.log(this.$store.state.chatbot.conversation.general.questions);
        },
      },
      material: {
        name: "material",
        text: "¡Listo! Aquí está tu material. Puedes editarlo como quieras. <br> Cuando termines, puedes aplicarlo a tus estudiantes",
        type: "custom-component",
        answersLoaded: false,
        answers: [],
        component: CreateMaterial,
        nextMessage: "¡Listo! Guardar y aplicar",
        nextQuestionIndex: "material_title",
        getAnswers: async () => {
          const conversation = this.$store.state.chatbot.conversation;
          const subjectName = conversation.subject.answer.name;
          const isLanguage =
            subjectName === "Lenguaje y comunicación / Lengua y Literatura";
          const school = this.$store.state.login.school;

          const buildItems = (questionsPayload) =>
            questionsPayload.map((q) => ({
              oa: q.oa
                ? { id: q.oa.id, description: q.oa.description }
                : null,
              subtag: q.subtag
                ? { id: q.subtag.id, description: q.subtag.description }
                : null,
            }));

          const emptyPage = (text) => ({
            questions: [],
            text: text || null,
            images: [],
            audio: null,
            additional_instruction: "",
            eje: null,
          });

          const pages = [];
          const pagePromises = [];

          const generateForPage = (pageObj, questionsPayload, text) => {
            pageObj.index = pages.length;
            pages.push(pageObj);
            if (!questionsPayload.length) return;
            const first = questionsPayload[0];
            const payload = {
              school,
              type: first.type,
              age: first.age,
              difficulty: first.difficulty,
              items: buildItems(questionsPayload),
            };
            if (isLanguage && text && text.id) payload.text_id = text.id;
            if (!isLanguage) payload.subject = subjectName;

            pagePromises.push(
              assistedMaterialService
                .generatePageQuestions(payload)
                .then((response) => {
                  pageObj.questions = (response && response.questions) || [];
                })
                .catch((error) => {
                  console.log("error generating page questions", error);
                })
            );
          };

          if (isLanguage) {
            const grouped = conversation.general.questions || {};
            const textKeyMap = {
              "Text - Audio Slider": "validate_text_slider",
              "Text - Fábula": "validate_text_fabula",
              "Text - Carta": "validate_text_carta",
              "Text - Poema": "validate_text_poema",
              "Text - Noticia": "validate_text_noticia",
              "Text - Novela": "validate_text_novela",
              "Text - Biografía": "validate_text_biografia",
              "Text - Expositivo": "validate_text_expositivo",
              "Text - Ensayo": "validate_text_ensayo",
            };

            for (const key of Object.keys(grouped)) {
              const resourceKey = textKeyMap[key];
              const text = resourceKey
                ? conversation[resourceKey] &&
                  conversation[resourceKey].createdText
                : "";
              const oas = grouped[key] || [];
              const questionsFromPage = [];

              oas.forEach((oa) => {
                const base = {
                  type: 0,
                  age: 4,
                  difficulty: "media",
                  oa: {
                    id: oa.id,
                    name: oa.full_name,
                    description: oa.description,
                  },
                  ...(resourceKey ? { text: text } : {}),
                };
                if (oa.options) {
                  oa.options.forEach((option) => {
                    for (let i = 0; i < option.count; i++) {
                      questionsFromPage.push({
                        ...base,
                        subtag: {
                          id: option.id,
                          description: option.description,
                        },
                      });
                    }
                  });
                } else {
                  for (let i = 0; i < oa.count; i++) {
                    questionsFromPage.push({ ...base });
                  }
                }
              });

              generateForPage(emptyPage(text), questionsFromPage, text);
            }
          } else {
            const questionsToCreate = [];
            if (!conversation.oa.optionalCheckbox) {
              const answers = conversation.oa.answers;
              answers.forEach((answer) => {
                for (let i = 0; i < answer.count; i++) {
                  questionsToCreate.push({
                    type: 0,
                    age: 4,
                    difficulty: "media",
                    oa: {
                      id: answer.id,
                      name: answer.full_name,
                      description: answer.description,
                    },
                  });
                }
              });
            } else {
              const oas = conversation.indicadores.answers;
              oas.forEach((oa) => {
                oa.options.forEach((option) => {
                  for (let i = 0; i < option.count; i++) {
                    questionsToCreate.push({
                      type: 0,
                      age: conversation.grade.answer.code,
                      difficulty: "media",
                      oa: {
                        id: oa.id,
                        name: oa.name,
                        description: oa.description,
                      },
                      subtag: {
                        id: option.id,
                        description: option.description,
                      },
                    });
                  }
                });
              });
            }
            generateForPage(emptyPage(null), questionsToCreate, null);
          }

          await Promise.all(pagePromises);

          const createdMaterial = {
            name: "Agregar título del material",
            pages,
            duration: 60,
            style: 0,
            description: "Agrega una descripcion",
            profession: 6,
            topic: null,
            subject: null,
            grade: null,
            school,
            created_by: this.$store.state.login.user_id,
            __prepared: true,
          };

          this.$store.commit("chatbot/updateMessage", {
            name: "material",
            key: "createdMaterial",
            value: createdMaterial,
          });

          return [];
        },
        routine: () => {},
      },
      material_title: {
        name: "material_title",
        text: "¡Listo! Se ha creado tu material. Define un título para tu material y duración de la evaluación",
        type: "multiple-text",
        answersLoaded: true,
        showAnswers: true,
        answered: true,
        answers: [
          {
            name: "title",
            label: "Título",
            type: "text",
            value: "",
            class: "col-8 px-0",
          },
          // {
          //   name: "duration",
          //   label: "Duración (minutos)",
          //   type: "number",
          //   value: 60,
          //   class: "col-8 px-0",
          // },
        ],
        nextQuestionIndex: "application",
        routine: async () => {
          this.$store.commit("chatbot/updateMessage", {
            name: "status",
            key: "loading",
            value: true,
          });
          const conv = this.$store.state.chatbot.conversation;
          const rawTitle =
            conv.material_title &&
            conv.material_title.answers &&
            conv.material_title.answers[0]
              ? conv.material_title.answers[0].value
              : "";
          const title = (rawTitle == null ? "" : String(rawTitle)).trim();
          const grade = conv.grade.answer.original_name;
          const subject = conv.subject.answer.name;
          // If the user left the title blank (or whitespace-only), auto-build
          // it from the grade + subject so the material is still created.
          const newTitle = title ? title : `${grade} ${subject}`;
          const duration =
            this.$store.state.chatbot.conversation.material_title.answers
              .length > 1
              ? parseInt(
                  this.$store.state.chatbot.conversation.material_title
                    .answers[1].value
                )
              : 60;
          let createdMaterial =
            this.$store.state.chatbot.conversation.material.createdMaterial;
          createdMaterial.name = newTitle;
          createdMaterial.duration = duration;
          createdMaterial.grade =
            this.$store.state.chatbot.conversation.grade.answer.code;
          createdMaterial.subject =
            this.$store.state.chatbot.conversation.subject.answer.enum_code;
          createdMaterial.ia_generated = true;
          return customMaterialService
            .createChatbotMaterial(createdMaterial)
            .then((response) => {
              this.$store.commit("chatbot/updateMessage", {
                name: "material",
                key: "createdMaterial",
                value: response,
              });
              this.$store.commit("chatbot/updateMessage", {
                name: "material",
                key: "pdfUrl",
                value: response.pdf,
              });
              this.$store.commit("chatbot/updateMessage", {
                name: "status",
                key: "loading",
                value: false,
              });
            })
            .catch((error) => {
              console.log(error);
            });
        },
        getAnswers() {
          return new Promise((resolve) => {
            resolve(this.answers);
          });
        },
      },
      application: {
        name: "application",
        text: () => {
          // const copyIcon = this.copyIcon;
          // const reviewIcon = this.reviewIcon;
          // const backIcon = this.backIcon;

          // return `<strong>Creamos para ti tres estudiantes de prueba.<br> Ahora puedes:</strong><br>
          //   <ol>
          //     <li> <img src='${copyIcon}' width='22px' class='pl-1 mb-2'/></img> Copiar el link para realizar una evaluación </li>
          //     <li> <img src='${reviewIcon}' width='22px' class='pl-1 mb-2'/></img> Revisar una evaluación terminada. </li>
          //     <li> <img src='${backIcon}' width='22px' class='pl-1 mb-2'/></img> Devolverla a su estado original. </li>
          //     <li> Chequear el porcentaje de logro. </li>
          //     <li> Ver el nivel de logro de cada OA. </li>
          //     <li> Aplicar un nuevo material ya creado. </li>
          //     <li> Revisar otras aplicaciones que hayas hecho en tu curso </li>
          //     <li> Añadir nuevos estudiantes a tu curso </li>
          //   </ol>`;

          // return `<strong> Ahora puedes aplicar tu material:</strong><br>
          //   <ol>
          //     <li> <img src='${copyIcon}' width='22px' class='pl-1 mb-2'/></img> Copiar el link para realizar una evaluación </li>
          //     <li> <img src='${reviewIcon}' width='22px' class='pl-1 mb-2'/></img> Revisar una evaluación terminada. </li>
          //     <li> <img src='${backIcon}' width='22px' class='pl-1 mb-2'/></img> Devolverla a su estado original. </li>
          //     <li> Chequear el porcentaje de logro. </li>
          //     <li> Ver el nivel de logro de cada OA. </li>
          //     <li> Descargar material en pdf </li>
          //   </ol>`;
          return "Ahora puedes descargar tu material";
        },
        type: "custom-component",
        component: ApplicationComponent,
        answersLoaded: true,
        answers: [],
        nextMessage: "Reiniciar chat",
        nextQuestionIndex: "reset",
        routine() {
          console.log("routine");
        },
        getAnswers() {
          return new Promise((resolve) => {
            // TODO: CAMBIAR ESTO, ES UNA SOLUCION PARCHE PERO LA IDEA ES TENER UNA VARIABLE PARA RENRIZAR CUSTOM COMPONENTS BAJO UNA CONDICION
            setTimeout(() => {
              resolve([]);
            }, 5000); // 1 second delay
          });
        },
      },
      ask_premium: {
        name: "ask_premium",
        text: `Adicionalmente, puedes crear otro material o ¡Usar uno de nuestra Vitrina de Materiales Premium! <img src=${require("@/assets/img/icono-estrella.svg")} width='10px' class='pb-1'/></img>`,
        type: "options",
        single_choice: true,
        answersLoaded: true,
        answersFlow: true,
        starIcon: this.starIcon,
        answers: [
          {
            name: "Crear otro material",
            isSelected: false,
            class: "col-5 pr-1 pl-0 pb-1",
            nextQuestionIndex: "reset",
          },
          {
            name: `Vitrina de Materiales Premium <img src=${require("@/assets/img/icono-estrella.svg")} width='10px' class='pb-1'/></img>`,
            isSelected: false,
            class: "col-5 pr-1 pl-0 pb-1",
            nextQuestionIndex: "premium_view",
          },
        ],
        routine() {
          this.nextQuestionIndex = this.answers.find(
            (ans) => ans.isSelected
          ).nextQuestionIndex;
        },
        getAnswers() {
          return new Promise((resolve) => {
            resolve(this.answers);
          });
        },
      },
      premium_view: {
        name: "premium_view",
        text: "¡Mira estos materiales premium! <br> Puedes aplicarlos a tus estudiantes o personalizarlos a tu gusto.",
        type: "custom-component",
        component: PremiumViewComponent,
        answersLoaded: true,
        answers: [],
        nextQuestionIndex: "reset",
        routine() {
          console.log("routine");
        },
        getAnswers() {
          return new Promise((resolve) => {
            resolve();
          });
        },
      },
    };
  },
  mounted() {
    let question = this.questions[this.currentQuestionIndex];
    this.messages.push(question);
    this.context[question.name] = {};
    this.$store.commit("chatbot/clear");
  },
  computed: {
    currentQuestion() {
      return this.questions[this.currentQuestionIndex];
    },
    school() {
      return this.$store.state.login.school;
    },
    year() {
      return this.$store.state.login.year;
    },
  },
  methods: {
    switchTextType(answers) {
      const hasText = answers.some((ans) => ans.resource_type === "Text");
      const hasNovela = answers.some(
        (ans) =>
          ans.resource_type === "Text" && ans.resource_type_detail === "Novela"
      );
      const hasFabula = answers.some(
        (ans) =>
          ans.resource_type === "Text" && ans.resource_type_detail === "Fábula"
      );
      const hasPoema = answers.some(
        (ans) =>
          ans.resource_type === "Text" && ans.resource_type_detail === "Poema"
      );
      const hasNoticia = answers.some(
        (ans) =>
          ans.resource_type === "Text" && ans.resource_type_detail === "Noticia"
      );
      const hasCarta = answers.some(
        (ans) =>
          ans.resource_type === "Text" && ans.resource_type_detail === "Carta"
      );
      const hasBiografia = answers.some(
        (ans) =>
          ans.resource_type === "Text" &&
          ans.resource_type_detail === "Biografía"
      );
      const hasExpositivo = answers.some(
        (ans) =>
          ans.resource_type === "Text" &&
          ans.resource_type_detail === "Expositivo"
      );
      const hasEnsayo = answers.some(
        (ans) =>
          ans.resource_type === "Text" && ans.resource_type_detail === "Ensayo"
      );
      const hasSlider = answers.some(
        (ans) => ans.resource_type_detail === "Audio Slider"
      );
      if (hasText) {
        if (hasSlider && !this.$store.state.chatbot.validate_text_slider) {
          return "text_topic";
        }
        if (hasNovela && !this.$store.state.chatbot.validate_text_novela) {
          return "text_topic_details_novela";
        } else if (
          hasFabula &&
          !this.$store.state.chatbot.validate_text_fabula
        ) {
          return "text_topic_details_fabula";
        } else if (hasPoema && !this.$store.state.chatbot.validate_text_poema) {
          return "text_topic_details_poema";
        } else if (
          hasNoticia &&
          !this.$store.state.chatbot.validate_text_noticia
        ) {
          return "text_topic_details_noticia";
        } else if (hasCarta && !this.$store.state.chatbot.validate_text_carta) {
          return "text_topic_details_carta";
        } else if (
          hasBiografia &&
          !this.$store.state.chatbot.validate_text_biografia
        ) {
          return "text_topic_details_biografia";
        } else if (
          hasExpositivo &&
          !this.$store.state.chatbot.validate_text_expositivo
        ) {
          return "text_topic_details_expositivo";
        } else if (hasEnsayo && !this.$store.state.login.validate_text_ensayo) {
          return "text_topic_details_ensayo";
        } else {
          return "material";
        }
      } else {
        return "material";
      }
    },
    handleCardClick(answer, msgidx, ansidx, max) {
      this.hasInteracted = true;
      if (this.messages[msgidx].name === this.currentQuestion.name) {
        this.selectCard(msgidx, ansidx, answer, max);
        this.selectAnswer();
      }
    },
    handleIncrease(opt, answer) {
      if (opt.price) {
        if (opt.count === 0) {
          if (this.cost + opt.price <= this.$store.state.login.points) {
            this.cost += opt.price;
            opt.count++;
            answer.oaInds++;
          } else {
            this.$toasted.error(
              "No cuentas con aportes suficientes para realizar esta acción!"
            );
          }
        } else {
          if (opt.count < 8) {
            opt.count++;
            answer.oaInds++;
          }
        }
      } else {
        opt.count++;
        answer.oaInds++;
      }
    },
    handleDecrease(opt, answer) {
      if (opt.count > 0) {
        if (opt.price && opt.count === 1) {
          this.cost -= opt.price;
          opt.count--;
          answer.oaInds--;
        } else {
          opt.count--;
          answer.oaInds--;
        }
      }
    },
    async continueChat() {
      this.hasInteracted = true;
      // hacer switch para disstintos tipos de pregunta
      switch (this.currentQuestion.type) {
        case "options":
          if (this.currentQuestion.single_choice) {
            this.context[this.currentQuestion.name] =
              this.currentQuestion.answers.find((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answer",
              value: this.context[this.currentQuestion.name],
            });
            if (this.context[this.currentQuestion.name].redirect) {
              window.location.href = this.context[this.currentQuestion.name].redirect;
              return;
            }
          } else {
            this.context[this.currentQuestion.name] =
              this.currentQuestion.answers.filter((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answers",
              value: this.context[this.currentQuestion.name],
            });
          }
          break;
        case "options-counter":
          this.context[this.currentQuestion.name] =
            this.currentQuestion.answers;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "answers",
            value: this.context[this.currentQuestion.name],
          });
          break;

        case "cards":
          if (this.currentQuestion.single_choice) {
            this.context[this.currentQuestion.name] =
              this.currentQuestion.answers.find((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answer",
              value: this.context[this.currentQuestion.name],
            });
          } else {
            this.context[this.currentQuestion.name] =
              this.currentQuestion.answers.filter((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answers",
              value: this.context[this.currentQuestion.name],
            });
          }
          break;
        case "hybrid-options":
          // si optionalCheckbox es true, entonces type es option-counter si no, es multiple choice como cards
          if (this.currentQuestion.optionalCheckbox) {
            this.context[this.currentQuestion.name].answers =
              this.currentQuestion.answers.filter((ans) => ans.isSelected);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answers",
              value: this.context[this.currentQuestion.name].answers,
            });
          } else {
            this.context[this.currentQuestion.name].answers =
              this.currentQuestion.answers.filter((ans) => ans.count > 0);
            this.$store.commit("chatbot/updateMessage", {
              name: this.currentQuestion.name,
              key: "answers",
              value: this.context[this.currentQuestion.name].answers,
            });
          }
          break;
        case "text-area":
          this.context[this.currentQuestion.name].textInput =
            this.currentQuestion.textInput;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "textInput",
            value: this.context[this.currentQuestion.name].textInput,
          });
          break;
        case "selector-options":
          this.context[this.currentQuestion.name] =
            this.currentQuestion.answers;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "answers",
            value: this.context[this.currentQuestion.name],
          });
          break;
        case "material":
          this.context[this.currentQuestion.name] =
            this.currentQuestion.answers;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "answers",
            value: this.context[this.currentQuestion.name],
          });
          break;
        case "multiple-text":
          this.context[this.currentQuestion.name] =
            this.currentQuestion.answers;
          this.$store.commit("chatbot/updateMessage", {
            name: this.currentQuestion.name,
            key: "answers",
            value: this.context[this.currentQuestion.name],
          });
          break;
        default:
          break;
      }

      this.messages.slice(-1)[0].answered = true;
      if (!this.currentQuestion.isFinal) {
        await this.currentQuestion.routine();
        // update store if the method updateStore exists in the question
        if (this.currentQuestion.updateStore) {
          this.currentQuestion.updateStore(this.context);
        }
        if (!this.currentQuestion.single_choice) {
          if (typeof this.currentQuestion.nextQuestionIndex === "function") {
            this.currentQuestionIndex = this.currentQuestion.nextQuestionIndex(
              this.context
            );
          } else {
            this.currentQuestionIndex = this.currentQuestion.nextQuestionIndex;
          }
        } else {
          this.currentQuestionIndex =
            this.context[this.currentQuestion.name] &&
            this.context[this.currentQuestion.name].nextQuestionIndex
              ? this.context[this.currentQuestion.name].nextQuestionIndex
              : this.currentQuestion.nextQuestionIndex;
        }
        if (this.currentQuestionIndex == "reset") {
          this.resetChat();
        } else {
          this.loadQuestion(this.currentQuestionIndex);
        }
        this.context["currentQuestionIndex"] = this.currentQuestionIndex;
        this.$store.commit("chatbot/updateMessage", {
          name: "currentQuestionIndex",
          key: "value",
          value: this.currentQuestionIndex,
        });
      }
    },
    selectCard(msgidx, answeridx, answer, max) {
      if (this.currentQuestion.single_choice) {
        this.messages[msgidx].answers.forEach((ans) => {
          if (ans.price && ans.isSelected) {
            this.cost -= ans.price;
          }
          ans.isSelected = false;
        });
      }
      if (answer.price && !answer.isSelected) {
        if (this.cost + answer.price <= this.$store.state.login.points) {
          if (
            !max ||
            (max &&
              this.messages[msgidx].answers.filter((ans) => ans.isSelected)
                .length < max)
          ) {
            this.cost += answer.price;
            answer.isSelected = true;
          } else {
            this.$toasted.error(
              "Ya has seleccionado el máximo de " + max + " elementos"
            );
          }
        } else {
          this.$toasted.error(
            "No cuentas con aportes suficientes para realizar esta acción!"
          );
        }
      } else {
        if (answer.price && answer.isSelected) {
          this.cost -= answer.price;
        }
        if (
          answer.isSelected ||
          !max ||
          (max &&
            this.messages[msgidx].answers.filter((ans) => ans.isSelected)
              .length < max)
        ) {
          this.messages[msgidx].answers[answeridx].isSelected =
            !this.messages[msgidx].answers[answeridx].isSelected;
        } else {
          this.$toasted.error(
            "Ya has seleccionado el máximo de " + max + " elementos"
          );
        }
      }
    },
    resetValues() {
      this.selectedCard = null;
    },

    setText(sourceObj, keyObj, targetObj, keyTarget) {
      return new Promise((resolve) => {
        // resolve content
        let content =
          typeof sourceObj[keyObj] === "function"
            ? sourceObj[keyObj]()
            : sourceObj[keyObj];

        // type effect
        let i = 0;
        // targetObj[keyTarget] = "";
        let timer = setInterval(() => {
          if (i < content.length && content.charAt(i)) {
            targetObj[keyTarget] += content.charAt(i);

            i++;

            this.$forceUpdate();
          } else {
            clearInterval(timer);
            resolve();
          }
        }, 5);
      });
    },
    loadQuestion(questionIndex) {
      try {
        console.log("loadQuestion");
        console.log(questionIndex);
        let question = this.questions[questionIndex];
        this.context[question.name] = {};
        this.messages.push(question);
      } catch (error) {
        console.log(error);
      }
    },

    goToStep(stepName) {
      this.hasInteracted = true;
      // Custom steps can request a full chat reset via go-to-step("reset");
      // route it through resetChat instead of loadQuestion (which would crash
      // looking up this.questions["reset"]).
      if (stepName === "reset") {
        this.resetChat();
        return;
      }

      // Eliminar el viewer (ultimo mensaje)
      this.messages.pop();
      // Eliminar el paso anterior contestado (la lista vieja)
      this.messages.pop();

      // Resetear el flag "answered" del paso destino
      let question = this.questions[stepName];
      if (question) {
        question.answered = false;
      }

      this.currentQuestionIndex = stepName;

      // Usar nextTick para forzar que Vue destruya el componente viejo
      // antes de crear el nuevo (evita reutilizacion por key=indice)
      this.$nextTick(() => {
        this.loadQuestion(stepName);
      });
    },

    selectAnswer() {
      if (this.currentQuestion.single_choice) {
        this.continueChat();
      }
    },
    // The vitrina hit a paid mode with no uses left: bring the chat — and its
    // highlighted "conseguir más usos" options — into view.
    scrollToChat() {
      this.hasInteracted = true;
      this.$nextTick(this.scrollToBottom);
    },

    scrollToBottom() {
      if (!this.hasInteracted) return;
      let container = document.querySelector(".global-container");
      // container.scrollIntoView();
      window.scrollTo(0, container.scrollHeight);
    },

    scrollToMsg(name) {
      if (!this.hasInteracted) return;
      if (skipAutoScroll(this.messages, name)) return;
      const msgRef = this.$refs[`msgRef-${name}`];
      if (!msgRef || !msgRef.length) return;
      // El último, no el primero: el menú se vuelve a montar en cada vuelta y
      // `$refs` los acumula, así que `[0]` mandaba el scroll al menú de arriba
      // de todo en vez de al que se acaba de agregar.
      const parentMsg = msgRef[msgRef.length - 1].$el.parentNode;

      parentMsg.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
      // const scrollOffset = parentMsg.offsetTop;

      // window.scrollTo(0, scrollOffset);
    },
    resetChat() {
      // this.messages = [];
      // this.answers = {};
      // this.currentQuestionIndex = "type";
      // this.loadQuestion(this.currentQuestionIndex);
      this.$emit("toggle-reload");
    },
    handleCheckbox(msgidx, value) {
      this.messages[msgidx].optionalCheckbox = value;
      this.context[this.currentQuestion.name].optionalCheckbox = value;
    },
    setTextInput(msgidx, value) {
      this.messages[msgidx].textInput = value;
      this.context[this.currentQuestion.name].textInput = value;
    },
    handleSelectorChange(msgidx, idx, value) {
      this.messages[msgidx].answers[idx].selected = value;
      this.context[this.currentQuestion.name].answers =
        this.messages[msgidx].answers;
    },
  },
  watch: {
    cost(val) {
      this.$emit("set-cost", val);
    },
  },
};
</script>
<style>
.global-container {
  margin: 0;
  padding: 0;
  min-height: 100%;
}

.image-container {
  background-image: url("../../assets/img/botpie/mancha.svg");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center bottom;
}

.chat-box {
  margin: 10px;
  width: 100vw;
  margin-left: auto;
  margin-right: auto;
  align-items: space-between;
  justify-content: space-between;
}

/* RESET BUTTON */
/* CONTINUE BUTTON */
.reset-button {
  border-radius: 5px;
  border: 2pt solid rgb(0, 0, 0) !important;
  font-family: "Ubuntu Medium", Arial, sans-serif;
  font-weight: bold; /* Aplica negrita al texto */
  cursor: pointer;
}
</style>
